import { PredictionsProvider } from './context';
import { UpdatesProvider } from 'src/Modules/Arbitrage/context/updatesContext';

interface Props {
  children: React.ReactNode;
}

export const PredictionsProviders = ({ children }: Props) => {
  return (
    <UpdatesProvider scope="predictions">
      <PredictionsProvider>{children}</PredictionsProvider>
    </UpdatesProvider>
  );
};
